import React from "react";
import useMetaTags from "../../hooks/useMetaTags";
import Services_we_offer from "../../component/Services_Component/Services_we_offer";
import Custom_section from "../../component/Services_Component/Custom_services_section";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import Boost_section from "../../component/Services_Component/Boost_section";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import { AssistanceSection, BenefitSection, BoostSection, CustomSection, FAQ, ServicesSection } from "../../Data/All_Services_Data/webDevelopmentData";
import { Link } from "react-router-dom";

const WebsiteDesignDevelopment = () => {
  useMetaTags({
    title: "Expert Custom Web Development Services | Warrgyizmorsch",
    description:
      "Fuel growth with customized web development. We create secure, high-performing, and scalable websites that reflect your brand's individual objectives.",
    keywords:
      "web development, web development services, web development agency, website development, website development company, custom web development, custom website developer, website developers, website design companies, website development agencies, web software development, website programming company",
  });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                Expert Web Development to Move up Your Brand
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/website.avif"
                loading="lazy"
                alt="heading_image"
              />
              <p>
                At Warrgyizmorsch we think your website should be more than just
                an online brochure – it should be a tool that lifts your brand
                and delivers real results. Our{" "}
                <Link
                  style={{
                    color: "blue",
                    fontWeight: "bold",
                  }}
                  to={"/"}
                >
                  Web development
                </Link>{" "}
                team loves building sites that look great, work beautifully and
                align with your goals. We’ve helped many businesses take their
                digital presence to the next level and we can do the same for
                you. Whether you want to revamp your existing site or build
                something completely new from scratch we bring expertise,
                creativity and precision to every project. With the right
                strategy and design your website becomes a hotbed of
                opportunity. We’re not just website developers – we’re your
                digital growth partners. Let’s move your brand forward with
                thoughtful web development that makes a difference.
              </p>
            </div>
            {/* Business Vision section  */}
            <Services_we_offer data={ServicesSection} />

            {/* Transform Your business  */}
            <Custom_section data={CustomSection} />

            {/* Benefits of our website  */}
            <Benefits_section data={BenefitSection} />

            {/* Boost your Business  */}
            <Boost_section data={BoostSection} />

            {/* Need assistance with web application  */}
            <Assistance_section data={AssistanceSection} />

            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
};

export default WebsiteDesignDevelopment;
